module.exports = __webpack_public_path__ + "static/media/book1.8d07beb9.pdf";